const ALPHANUMERIC = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const randomString = (length?: number) => {
	if (!length) {
		return `Randomly generated: ${Math.round(Math.random() * 100)}`;
	}
	let rs = '';
	for (let i = 0; i < length; i++) {
		rs += ALPHANUMERIC.charAt(Math.floor(Math.random() * ALPHANUMERIC.length));
	}
	return rs;
};

const generateUniqueId = (prefix = 'id') =>
	`${prefix}-${Math.random().toString(36).substring(2, 9)}`;

export { randomString, generateUniqueId };
